import { Component, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { DialogResult, DialogResultType } from "../../DialogResult";
import { ReportEmbeddedType, ReportSource } from "../../../api/models";
import { ReportExportService } from "../../../api/services";

export interface EditReportEmbeddedTypeDialogData {
  dialogTitle: string;
  reportEmbeddedType: ReportEmbeddedType;

  reportSources: ReportSource[];
}

@Component({
  selector: "edit-report-embedded-type-dialog",
  styleUrls: ["edit-report-embedded-type-dialog.component.css"],
  templateUrl: "./edit-report-embedded-type-dialog.component.html",
})
export class EditReportEmbeddedTypeDialogComponent {
  public Result: DialogResult;
  public uploadingReportEmbeddedType: boolean = false;
  public reportPages: string[];
  public newReportPage: string;

  constructor(
    public dialogRef: MatDialogRef<EditReportEmbeddedTypeDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: EditReportEmbeddedTypeDialogData,
    private reportExportService: ReportExportService
  ) {
    this.Result = new DialogResult();
    this.Result.ResultType = DialogResultType.Cancel;
    this.Result.ResultData = null;

    this.reportPages = this.loadReportPages(this.data.reportEmbeddedType.reportPages);
  }

  onCancelClick(): void {
    this.dialogRef.close(this.Result);
  }

  onConfirmClick(): void {

    this.uploadingReportEmbeddedType = true;

    if (this.data.reportEmbeddedType.reportEmbeddedTypeId == -1) {
      const callParams: ReportExportService.ReportExportCreateReportEmbeddedTypeParams = {
        name: this.data.reportEmbeddedType.name,
        reportSourceId: this.data.reportEmbeddedType.reportSourceId,
        reportPages: this.getReportPages(),
        filterPage: this.data.reportEmbeddedType.filterPage
      };

      this.reportExportService
        .reportExportCreateReportEmbeddedType(callParams)
        .subscribe((result) => {
          this.Result.ResultType = DialogResultType.Ok;
          this.Result.ResultData = result;
          this.dialogRef.close(this.Result);
        }, (error) => {
          alert(error);
        });

    } else {
      const callParams: ReportExportService.ReportExportUpdateReportEmbeddedTypeParams = {
        reportEmbeddedTypeId: this.data.reportEmbeddedType.reportEmbeddedTypeId,
        name: this.data.reportEmbeddedType.name,
        reportSourceId: this.data.reportEmbeddedType.reportSourceId,
        reportPages: this.getReportPages(),
        filterPage: this.data.reportEmbeddedType.filterPage
      };

      this.reportExportService
        .reportExportUpdateReportEmbeddedType(callParams)
        .subscribe((result) => {
          this.Result.ResultType = DialogResultType.Ok;
          this.Result.ResultData = result;
          this.dialogRef.close(this.Result);
        }, (error) => {
          alert(error);
        });
    }
  }

  getReportPages(): string {
    return this.reportPages.join(",");
  }

  loadReportPages(reportPagesString: string): string[] {
    if (reportPagesString == null || reportPagesString.length > 0) {
      return reportPagesString.split(",");
    }

    return [];
  }

  addReportPage(): void {
    this.reportPages.push(this.newReportPage);
    this.newReportPage = "";
  }

  removeReportPage(index: number): boolean {
    if (index >= 0 && index < this.reportPages.length) {
      this.reportPages.splice(index, 1);
    }

    return false;
  }

  movePageUp(index: number): boolean {
    if (this.reportPages.length > 0 && index > 0 && index < this.reportPages.length) {
      var tmp = this.reportPages[index - 1];
      this.reportPages[index - 1] = this.reportPages[index];
      this.reportPages[index] = tmp;
    }

    return false;
  }

  movePageDown(index: number): boolean {
    if (this.reportPages.length > 0 && index >= 0 && index < (this.reportPages.length - 1)) {
      var tmp = this.reportPages[index + 1];
      this.reportPages[index + 1] = this.reportPages[index];
      this.reportPages[index] = tmp;
    }

    return false;
  }
}
